import { IPublicClientApplication } from "@azure/msal-browser";

export async function internalFetch<T>(params: {
  msal: IPublicClientApplication;
  scopes: string[];
  url: string;
  method?: string;
  body?: unknown;
}): Promise<T> {
  const accounts = params.msal.getAllAccounts();
  if (!accounts.length) {
    throw new Error("No active account");
  }

  const token = await params.msal.acquireTokenSilent({
    account: accounts[0],
    scopes: params.scopes,
  });

  const accessToken = token.accessToken;
  if (!accessToken) {
    throw new Error("Missing MSAL accessToken");
  }

  const isFormData = params.body instanceof FormData;

  const res = await fetch(params.url, {
    method: params.method || "GET",
    headers: {
      ...(isFormData ? {} : { "Content-Type": "application/json" }),
      Authorization: `Bearer ${accessToken}`,
      accept: "*/*",
    },
    body: isFormData
      ? (params.body as FormData)
      : params.body
        ? JSON.stringify(params.body)
        : undefined,
  });

  const contentType = res.headers.get("content-type") || "";

  if (!res.ok) {
    const raw = await res.text();
    let json: any;
    if (contentType.includes("application/json")) {
      try {
        json = JSON.parse(raw);
      } catch {
        /* ignore */
      }
    }
    const rawMessage =
      json?.error?.message ?? json?.error?.displayMessage ?? res.statusText;
    const message =
      typeof rawMessage === "string" ? rawMessage : JSON.stringify(rawMessage);
    throw new Error(message);
  }

  if (contentType.includes("application/json")) {
    return (await res.json()) as T;
  }

  if (
    contentType.startsWith("image/") ||
    contentType.startsWith("video/") ||
    contentType.includes("application/pdf") ||
    contentType.includes("application/octet-stream")
  ) {
    return (await res.blob()) as unknown as T;
  }

  return (await res.text()) as unknown as T;
}
